import { useNavigation } from "react-router";

/** Show the veil only while the router is actually loading the next page. */
export function MarketingTransition({
  children,
}: {
  children: React.ReactNode;
}) {
  const navigation = useNavigation();
  const loading = navigation.state !== "idle";

  return (
    <div className="flex min-h-dvh flex-1 flex-col" aria-busy={loading}>
      {children}
      {loading && (
        <div className="marketing-transition-veil" role="status">
          <span className="sr-only">Loading page…</span>
        </div>
      )}
    </div>
  );
}
